// src/components/Projects.js
import React from 'react';
import businessHubImage from '../assets/finance_building.webp';
import bridge_1 from '../assets/bridge_1.jpeg';
import bridge_2 from '../assets/river_bridge.webp';
import city_court from '../assets/city_court.webp';
import building_2 from '../assets/building_2.png';

import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
  Image,
  Tag,
  Link,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { IoLocationOutline, IoTimeOutline } from 'react-icons/io5';
import { BsTextareaResize } from 'react-icons/bs';
import { Link as RouterLink } from 'react-router-dom'; 

// Reusable Project Card Component
const ProjectCard = ({ image, tags, title, description, details, imageSide = 'left' }) => {
  const direction = { base: 'column', md: imageSide === 'left' ? 'row' : 'row-reverse' };

  return (
    <Flex
      direction={direction}
      bg="blue.900" // A slightly darker shade for the card itself
      p={8}
      borderRadius="lg"
      gap={8}
      align="center"
    >
      {/* Image Box */}
      <Box flex="1" position="relative">
        <Image src={image} alt={title} borderRadius="md" w="full" />
        <HStack position="absolute" bottom={4} left={4} spacing={2}>
          {tags.map((tag) => (
            <Tag key={tag} size="md" variant="solid" colorScheme="blackAlpha">
              {tag}
            </Tag>
          ))}
        </HStack>
      </Box>

      {/* Text Content Box */}
      <VStack flex="1" align="flex-start" spacing={4} color="white">
        <Heading as="h3" size="lg">{title}</Heading>
        <Text color="gray.300">{description}</Text>
        <VStack align="flex-start" spacing={2}>
          {details.map((detail) => (
            <HStack key={detail.label}>
              <Icon as={detail.icon} color="orange.400" />
              <Text fontSize="sm">{detail.label}: {detail.value}</Text>
            </HStack>
          ))}
        </VStack>
        {/* <Link href="#" color="orange.400" fontWeight="bold">
          Learn more <Icon as={ArrowForwardIcon} />
        </Link> */}
      </VStack>
    </Flex>
  );
};

export default function Projects() {
  const projectsData = [
    {
      title: 'Oromia Legal Research and Training Institute',
      description: "A state-of-the-art institutional facility designed to foster legal education and research. This project features modern lecture halls, a comprehensive library, and collaborative workspaces, all constructed to the highest standards of quality and durability to serve the region's legal community for decades.",
      image:building_2,
      tags: ['2020-2025', 'Commercial Construction'],
      details: [
        { icon: IoLocationOutline, label: 'Location', value: 'Ethiopia Oromia' },
        { icon: BsTextareaResize, label: 'Total Area', value: '18,000 square meters' },
        { icon: IoTimeOutline, label: 'Duration', value: '1Y, 3M' },
      ],
      imageSide: 'left',
    },
    {
      title: 'Adama City High Court Office B+G+4  Building',
      description: "This landmark B+G+4 high court building was engineered to balance imposing civic architecture with modern functionality. It includes secure judicial chambers, public-facing administrative offices, and advanced record-keeping facilities, delivered on-time and within budget to enhance the city's judicial infrastructure.",
      image: city_court,
      tags: ['2024-2025', 'Commercial Construction'],
      details: [
        { icon: IoLocationOutline, label: 'Location', value: 'Ethiopia, Oromia' },
        { icon: BsTextareaResize, label: 'Total Area', value: '500 square meters' },
        { icon: IoTimeOutline, label: 'Duration', value: '1Y, 2M' },
      ],
      imageSide: 'right',
    },
  ];

  return (
    <Box as="section" bg="blue.800" py={{ base: 16, md: 24 }} id="projects">
      <VStack maxW="7xl" mx="auto" px={8} spacing={12}>
        {/* Section Header */}
        <VStack spacing={4} textAlign="center">
          <Text color="orange.400" fontWeight="bold">Recent Projects</Text>
          <Heading as="h2" size="2xl" fontWeight="bold" color="white">
            Our <Text as="span" color="orange.400">Completed</Text> Projects
          </Heading>
        </VStack>

        {/* Projects List */}
        <VStack spacing={12} w="full">
          {projectsData.map((project) => (
            <ProjectCard key={project.title} {...project} />
          ))}
        </VStack>

        {/* View All Button */}
        <Button colorScheme="orange" size="lg"
                as={RouterLink} // <<-- ADD THIS
                    to="/projects"    // <<-- ADD THIS
        >
          View All Projects
        </Button>
      </VStack>
    </Box>
  );
}